module.exports = require('./PayeezyView');
